module.exports = require('./PayeezyView');
